import { render, staticRenderFns } from "./MonetaryCompensationConfirm.vue?vue&type=template&id=82985a7e"
import script from "./MonetaryCompensationConfirm.vue?vue&type=script&lang=js"
export * from "./MonetaryCompensationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports